import React from 'react';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';
import auth, { LoginDialog } from '@ifeng/ui_pc_auth';
import errorBoundary from '@ifeng/errorBoundary';

/**
 * 定义 UserInfo 组件
 */
class UserInfo extends React.PureComponent {
    state = {
        userInfo: auth.isLogin() ? auth.getUserInfo() : null,
    };

    loginId = auth.uuid();

    componentDidMount() {
        this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, userInfo => {
            this.setState({
                userInfo,
            });
        });
        this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
            this.setState({
                userInfo: null,
            });
        });
    }

    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }

    handleLoginIn = () => {
        auth.login(this.loginId);
    };

    handleLoginOut = () => {
        auth.logout();
    };

    /**
     * 渲染组件
     */
    render() {
        const { userInfo } = this.state;
        const isLogin = auth.isLogin();
        let login = '';

        if (isLogin) {
            login = (
                <div className={styles.login}>
                    <span className={styles.login_info}>
                        <a href="//id.ifeng.com/my/info" target="_blank" rel={rel}>
                            {userInfo.userName}
                        </a>{' '}
                    </span>
                    <span className={styles.login_out} onClick={this.handleLoginOut}>
                        <a href="#">退出</a>
                    </span>
                </div>
            );
        } else {
            login = (
                <div>
                    <span className={styles.login} onClick={this.handleLoginIn}>
                        <a>登录</a>
                    </span>
                    <LoginDialog id={this.loginId} />
                </div>
            );
        }

        return (
            <div>
                <div className={styles.hdpFeebk}>
                    <a href="//help.ifeng.com/" target="_blank" rel={rel}>
                        用户反馈
                    </a>
                </div>
                {login}
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
UserInfo.propTypes = {};

/**
 * 定义组件默认属性
 * */
UserInfo.defaultProps = {};

export { UserInfo };
export default errorBoundary(UserInfo);
